"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Button = require("../Button");

var styles = {
  root: Object.assign({}, _Button.styles.root, {
    color: function color(props) {
      return props.outlineColor;
    },
    border: function border(props) {
      return "1px solid ".concat(props.outlineColor);
    },
    background: function background(props) {
      return props.backgroundColor;
    },
    '&:hover, &:active': {
      color: function color(props) {
        return props.backgroundColor;
      },
      background: function background(props) {
        return props.outlineColor;
      }
    }
  })
};
var _default = styles;
exports["default"] = _default;